import { LocalStorage } from '@vectord/utils';
import { useSyncExternalStore } from 'react';

import { isSnowFallSeasonActive } from './snowFall';

const DELIGHTS_STORAGE_KEY = 'delights_enabled';
const DELIGHTS_CHANGE_EVENT = 'delights-preference-change';

const ls = LocalStorage.getInstance(DELIGHTS_STORAGE_KEY);

export const hasDelightsInSeason = (): boolean => isSnowFallSeasonActive();

export const getDelightsPreference = (): boolean => {
  const stored = ls.config as boolean;
  return stored ?? hasDelightsInSeason();
};

export const setDelightsPreference = (enabled: boolean): void => {
  ls.config = enabled;
  window.dispatchEvent(new CustomEvent(DELIGHTS_CHANGE_EVENT));
};

const subscribe = (cb: () => void) => {
  window.addEventListener(DELIGHTS_CHANGE_EVENT, cb);
  return () => window.removeEventListener(DELIGHTS_CHANGE_EVENT, cb);
};

export const useDelightsEnabled = (): boolean => useSyncExternalStore(subscribe, getDelightsPreference);
